import React from 'react';
import useApp from './AppContext';

const HomeYard = () => {
    const app = useApp();
    const parsedCustomStyle = app.sessionToken?.CustomStyle
        ? JSON.parse(app.sessionToken.CustomStyle)
        : {};

    const logoPath = parsedCustomStyle.Logo
        ? `${app.serverUrl}${parsedCustomStyle.Logo}`
        : 'images/Logo-Yard.png';
    return (
        <div className='wrapper-home-yard'>
            <div className='main-screen'>
                <img src={logoPath} alt="Logo-Yard" />
            </div>
            <div className='logos-screen'>
                <img src={app.theme === "light" ? "/images/Logo-Yard.png" : "/images/Logo-YardDark.png"} alt="Logo" />
                <img src={app.theme === "light" ? "/images/DefaultLogo.png" : "/images/DefaultLogo.png"} alt="Logo" />
            </div>
        </div>
    );
};

export default HomeYard;